module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbjl-box"
  }, [_c('div', {
    ref: "listContainer",
    staticClass: "zbjl-container",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "zbjl-steps"
  }, [_c('div', {
    staticClass: "zbjl-step zbjl-step-left",
    on: {
      "click": _vm.handleShenqing
    }
  }, [_c('span', {
    staticClass: "zbjl-step-num"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "zbjl-step-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingzhibo')))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/image/jindu_heng@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbjl-step zbjl-step-right",
    on: {
      "click": _vm.handleKaishi
    }
  }, [_c('span', {
    staticClass: "zbjl-step-num1"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "zbjl-step-text"
  }, [_vm._v(_vm._s(_vm.$t('all.kaishizhibo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "zbjl-title"
  }, [_c('div', {
    staticClass: "zbzx-title-box"
  }, [_c('span', {
    staticClass: "zbzx-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _c('span', {
    staticClass: "zbzx-title-span1"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "zbjl-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('zbList', {
      key: index,
      attrs: {
        "data": item,
        "type": 1
      }
    })
  }), 1), _vm._v(" "), (!_vm.isLoading && _vm.loaded && _vm.list.length === 0) ? _c('div', {
    staticClass: "zbjl-kong"
  }, [_c('kong')], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53d6ed6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/zhibojilu/zhibojilu.vue
// module id = 979
// module chunks = 1